<template lang="pug">
  .error-404
    template(v-if="!isSinglePatient")
      h1.page-title Error 404
      h3.heading Page not found
      p
        router-link(to="/dashboard" exact title="Dashboard" aria-label="dashboard" class="btn") Return to Dashboard
    template(v-if="isSinglePatient")
      h1.page-title Error 404
      h3.heading Patient not found, please close this window and try again
</template>

<script>
export default {
  name: 'NotFound',
  props: {
    isSinglePatient: {
      type: Boolean,
      required: false,
      default: false
    }
  }
};
</script>

<style lang="scss">
  @keyframes fade-in-up {
    0% {
    	opacity: 0;
    	transform: translateY(50%);
    }
    100% {
    	opacity: 1;
    	transform: translateY(0);
    }
  }

	.error-404 {
		max-width: $bp3;
		margin: 0 auto;
		padding: $base-spacing;
		color: $error-color;
		background: #fff;
		@include drop-shadow;
		display: flex;
		flex-direction: column;
    justify-content: center;
		transition: all .25s cubic-bezier(1.0, 0.5, 0.8, 1.0);
		animation: fade-in-up 0.5s ease-in;

		* {
			text-align: center;
		}
		p {
			margin-top: $base-spacing;
		}
	}

</style>
